// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_PblJQ","after-pay-steps":"after-pay-steps_fEJz3","step":"step_Dlp1S","text":"text_0g9xc"};